<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-list>
          <show-field :value="item.nombre" :label="$t('proveedor.labels.nombre')" icon="badge" />
        </v-list>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-list>
          <show-field :value="item.cuit" :label="$t('proveedor.labels.cuit')" icon="numbers" />
        </v-list>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-list>
          <show-field :value="item.email" :label="$t('proveedor.labels.email')" icon="email" />
        </v-list>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-list>
          <show-field :value="item.telefono" :label="$t('proveedor.labels.telefono')" icon="phone" />
        </v-list>
      </v-col>
    </v-row>

    <v-divider class="my-3" />
    <div class="text-subtitle-1 mb-2">Cuenta corriente</div>
    <p v-if="loadingCuenta">Cargando...</p>
    <template v-else>
      <p><strong>Deuda actual:</strong> ${{ Number(deuda || 0).toFixed(2) }}</p>
      <div class="text-caption mb-1">Últimos movimientos</div>
      <v-simple-table v-if="movimientos.length" dense>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Tipo</th>
            <th>Descripción</th>
            <th>Monto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="m in movimientos" :key="m.id">
            <td>{{ formatFecha(m.fecha) }}</td>
            <td>{{ labelTipo(m.tipo) }}</td>
            <td>{{ descripcionMovimiento(m) }}</td>
            <td :class="montoDisplay(m.monto).esPago ? 'success--text' : 'error--text'">
              {{ montoDisplay(m.monto).texto }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <p v-else class="text-caption">Sin movimientos.</p>
    </template>
  </div>
</template>

<script>
import { ShowField } from "@dracul/common-frontend";
import CuentaProveedorProvider from "../../../../compras/providers/CuentaProveedorProvider";
import { formatFechaVentas } from "../../../../ventas/utils/dateFormat";

const TIPO_LABELS = {
  DEUDA_ORDEN_COMPRA: "Deuda orden de compra",
  PAGO_ORDEN_COMPRA: "Pago orden de compra",
  PAGO_PARCIAL: "Pago parcial orden de compra",
  PAGO_TOTAL: "Pago total orden de compra",
};

export default {
  name: "ProveedorShowData",
  components: { ShowField },
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      deuda: null,
      movimientos: [],
      loadingCuenta: false,
    };
  },
  computed: {
    proveedorId() {
      return (this.item && (this.item.id || this.item._id)) || null;
    },
  },
  watch: {
    proveedorId(id) {
      if (id) this.loadCuenta();
      else {
        this.deuda = null;
        this.movimientos = [];
      }
    },
  },
  mounted() {
    if (this.proveedorId) this.loadCuenta();
  },
  methods: {
    formatFecha(val) {
      return formatFechaVentas(val);
    },
    labelTipo(tipo) {
      return (tipo && TIPO_LABELS[tipo]) || (tipo || "—");
    },
    descripcionMovimiento(m) {
      const partes = [];
      const desc = m.descripcion && String(m.descripcion).trim();
      if (desc) partes.push(desc);
      if (m.ordenCompraNumero != null && m.ordenCompraNumero !== "") {
        partes.push(`OC Nº ${m.ordenCompraNumero}`);
      }
      if (partes.length) {
        const conMedio = ["PAGO_ORDEN_COMPRA", "PAGO_PARCIAL", "PAGO_TOTAL"].includes(m.tipo);
        if (conMedio && m.medioDePago) {
          partes.push(`(${m.medioDePago})`);
        }
        return partes.join(" — ");
      }
      if (m.ordenCompraId) {
        return "Orden de compra";
      }
      return "—";
    },
    montoDisplay(monto) {
      const num = Number(monto);
      const invertido = -num;
      const esPago = invertido > 0;
      const signo = invertido > 0 ? "+" : "-";
      return {
        texto: `${signo}$${Math.abs(invertido).toFixed(2)}`,
        esPago,
      };
    },
    async loadCuenta() {
      const id = this.proveedorId;
      if (!id) return;
      this.loadingCuenta = true;
      try {
        const [rDeuda, rMov] = await Promise.all([
          CuentaProveedorProvider.cuentaProveedorDeuda(id),
          CuentaProveedorProvider.cuentaProveedorMovimientos(id, 1, 10),
        ]);
        const rawDeuda = rDeuda?.data?.cuentaProveedorDeuda;
        this.deuda = rawDeuda != null && rawDeuda !== undefined ? Number(rawDeuda) : 0;
        this.movimientos = rMov?.data?.cuentaProveedorMovimientos?.items || [];
      } catch (e) {
        console.error(e);
        this.deuda = 0;
        this.movimientos = [];
      } finally {
        this.loadingCuenta = false;
      }
    },
  },
};
</script>
